module.exports = __webpack_public_path__ + "img/frame (30).e87980ac.jpg";